import { useRouteLoaderData } from 'react-router';
import LocatorApi from '@/lib/LocatorApi';
import { getTipByPath } from '@/lib/getTip';
export default function homeRecyclingLoader({ params }) {
    const postcode = params.postcode;
    const localAuthority = LocatorApi.getInstance().get(`local-authority/${postcode}`);
    const tip = getTipByPath('/:postcode/home', { fallback: false });
    return { localAuthority, tip };
}
export function useHomeRecyclingLoaderData() {
    return useRouteLoaderData('home-recycling');
}
